import { uniqueId } from 'lodash';

import { ApiKey, ApiKeyAttributes } from 'dashboard/models/api-key';
import { ApiKeyInflection, ApiVersion } from 'lib/constants/api';
import { ApiModel } from 'lib/interfaces/api';

export const generateApiKeyId = () => uniqueId('api_');

export function createMockApiKey(attributes?: Partial<ApiKeyAttributes>, id?: string): ApiKey {
  return {
    attributes: {
      name: 'Default API key',
      note: 'Used for random stuff',
      value: 'persona_sandbox_1c4071e9-cbfe-46d2-9138-cde8159a61ea',
      'api-version': ApiVersion.V_2021_07_05,
      'api-key-inflection': ApiKeyInflection.Kebab,
      'api-attributes-blocklist': [],
      permissions: [],
      'ip-address-allowlist': [],
      'file-access-token-expires-in': 21600,
      'last-used-at': '2019-10-28T23:24:45.000Z',
      'expires-at': null,
      'created-at': '2019-10-28T23:24:45.000Z',
      'rate-limit': null,
      ...attributes,
    },
    id: id || generateApiKeyId(),
    type: ApiModel.ApiKey,
  };
}
